import { render, staticRenderFns } from "./Customers.vue?vue&type=template&id=4cdb4648&scoped=true&"
import script from "./Customers.vue?vue&type=script&lang=js&"
export * from "./Customers.vue?vue&type=script&lang=js&"
import style0 from "./Customers.vue?vue&type=style&index=0&id=4cdb4648&lang=scss&scoped=true&"
import style1 from "./Customers.vue?vue&type=style&index=1&id=4cdb4648&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdb4648",
  null
  
)

export default component.exports